try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { RTEText } from '@design-system/rte-text';
import UITooltip from '@phx-husky/tooltip';
import classNames from 'classnames';
import { forwardRef } from 'react';

const Tooltip = forwardRef(({ className, tooltipWindowClassName, portalQuerySelector, label, text, content, isTooltipContentInteractive = false, icon = 'tooltip', onClickTooltip, onBlurTooltip, }, ref) => (jsx("div", Object.assign({ ref: ref, className: classNames('cds-tooltip', className) }, { children: jsx(UITooltip, Object.assign({ placement: "top-end", className: classNames('cds-tooltip-window', tooltipWindowClassName), title: text && jsx(RTEText, { text: text }) }, { content, isTooltipContentInteractive, portalQuerySelector }, { children: jsx(Button, Object.assign({ variant: "subtle-icon", iconPrefix: { props: { icon } }, className: "cds-tooltip__button", onClick: onClickTooltip, onBlur: onBlurTooltip }, { children: label })) })) }))));

export { Tooltip };
